import axios from "axios";
import api from "./axiosInstance";
import { createHeaders, createAuthHeaders } from "./Constant";

const hostname = window.location.hostname;
const isLocal = hostname === "localhost" || hostname === "127.0.0.1";

const baseMap = {
  "customer-vkyc.finhub.habilelabs.io": "https://endpoint-gateway.finhub.habilelabs.io/vkyc-backend/api", // prod
  "endpoint-gateway-test.finhub.habilelabs.io": "https://endpoint-gateway-test.finhub.habilelabs.io/vkyc-backend/api", // test 
  "customer-vkyc-stage.finhub.habilelabs.io": "https://endpoint-gateway-stage.finhub.habilelabs.io/vkyc-backend/api",  // stage
};

const baseURL = isLocal
  ? "http://localhost:8000/api"
  : baseMap[hostname] || "https://endpoint-gateway-stage.finhub.habilelabs.io/vkyc-backend/api";

console.log('SessionsService - Base URL:', baseURL);
console.log('SessionsService - Hostname:', hostname);
console.log('SessionsService - Is Local:', isLocal);

export const sessionsService = {
  async getSessions(user, limit = 50, offset = 0, includeData = true) {
    const url = `${baseURL.replace('/v1', '')}/v1/vkyc/sessions`;
    
    const response = await api.get(url, {
      headers: {
        ...createAuthHeaders(user),
        "Content-Type": "application/json",
      },
    });
    
    return response.data;
  },

  async updateSession(identifier, updateData, user) {
    const url = `${baseURL.replace('/v1', '')}/v1/vkyc/session/${identifier}`;
    
    const response = await axios.patch(url, updateData, {
      headers: { 
        ...createAuthHeaders(user),
        'Content-Type': 'application/json',
        'company_id': user?.company?.id
      }
    });
    
    return response.data;
  },
};